<template>
    <Popup :showPopup="unaddressedPop" addedClass="unaddressed" header="Are you Sure?" @close-popup="$emit('close-unaddressed-pop')">
        <template v-slot:content>
            <div class="unaddressedHistory" v-if="unaddressedNotes && unaddressedNotes.length > 0 ">
                <div v-for="(note, index) in unaddressedNotes" class="unaddressedNote" :key="index">
                    <div>Marked {{ note.FlaggedAs ? 'Unaddressed' : 'Addressed' }}</div>
                    <div class='timestamp'>
                        <div class='disclaimer'>
                            <span class='name'>{{ note.descrip1 }}</span>
                        </div> 
                        <label class='small'>{{ formatDatetime(note.ActionTimestamp, note.preserve) }}</label>
                    </div>
                </div>
            </div>
            <p class="error" v-if="unaddressed">All previous calls and texts between this customer and {{ accountRefname }} will be marked addressed.</p>
        </template>

        <template v-slot:buttons>
            <svg v-if="loadingUnaddressedChange" class="load"> 							
                <circle cx="50%" cy="50%" r="42.5%" stroke-width="7.5%" fill="none"></circle>
            </svg>
            <div v-else>
                <button class="alert" @click="$emit('submit-unaddressed-change')" v-if="!unaddressed">Mark Unaddressed</button>
                <button class="alert" @click="$emit('submit-unaddressed-change')" v-else>Mark Addressed</button>
            </div>
        </template>
    </Popup>
</template>

<script>
import moment from 'moment-timezone';
import Popup from '@/components/Popup';

export default {
    name: 'UnaddressedPopup',
    props: ['unaddressedPop', 'unaddressedNotes', 'unaddressed', 'accountRefname', 'loadingUnaddressedChange'],
    components: { Popup },
    methods: {
        formatDatetime: function (timestamp, preserve){
			if (preserve) {
				return moment(timestamp).format('MMMM DD, YYYY hh:mm A');
			} else {
				return moment(timestamp).add(moment.tz.zone('America/Chicago').utcOffset(moment(timestamp)) / 60, 'hours').format('MMMM DD, YYYY hh:mm A');
			}
		}
    }
}
</script>